import { render, staticRenderFns } from "./OtherContactsDialog.vue?vue&type=template&id=aefab884&scoped=true"
import script from "./OtherContactsDialog.vue?vue&type=script&lang=ts"
export * from "./OtherContactsDialog.vue?vue&type=script&lang=ts"
import style0 from "./OtherContactsDialog.vue?vue&type=style&index=0&id=aefab884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefab884",
  null
  
)

export default component.exports